import { render, staticRenderFns } from "./ShippingBox.vue?vue&type=template&id=1b06e836&scoped=true&"
import script from "./ShippingBox.vue?vue&type=script&lang=js&"
export * from "./ShippingBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b06e836",
  null
  
)

export default component.exports